import { motion } from "framer-motion";
import { Star, Quote, MapPin, MessageSquareHeart } from "lucide-react";
import { TESTIMONIALS } from "../data/content";

const Stars = ({ count }) => (
  <div className="flex gap-0.5" aria-label={`${count} estrelas`}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
    ))}
  </div>
);

export const Testimonials = () => {
  return (
    <section id="avaliacoes" data-testid="testimonials-section" className="py-20 sm:py-28 bg-[#0A1128]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="inline-flex items-center gap-2 rounded-full border border-sky-400/30 bg-sky-400/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-sky-300">
            <MessageSquareHeart className="h-3.5 w-3.5" />
            Avaliações de Clientes
          </span>
          <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Quem já sentiu o efeito novo
          </h2>
          <p className="mt-4 text-base text-slate-400 leading-relaxed">
            Clientes satisfeitos em todo o Grande Porto, do sofá da sala ao
            telhado da moradia.
          </p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
              className="card-glow relative flex flex-col rounded-3xl border border-white/10 bg-[#101D42] p-7"
            >
              <Quote className="absolute top-6 right-6 h-7 w-7 text-sky-400/20" />
              <Stars count={t.rating} />
              <p className="mt-4 flex-1 text-sm sm:text-[15px] text-slate-300 leading-relaxed">
                “{t.text}”
              </p>
              <footer className="mt-6 flex items-center justify-between gap-3 border-t border-white/5 pt-4">
                <div>
                  <p className="font-display text-sm font-bold text-white">{t.name}</p>
                  <p className="mt-0.5 flex items-center gap-1 text-xs text-slate-400">
                    <MapPin className="h-3 w-3 text-sky-400" />
                    {t.city}
                  </p>
                </div>
                <span className="rounded-full border border-sky-400/25 bg-sky-400/10 px-3 py-1 text-[11px] font-semibold text-sky-300 whitespace-nowrap">
                  {t.service}
                </span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
